import { MenuItemData } from "./navigationMenu/MenuItemsData";

type PageMenuItemData = NonNullable<
  Extract<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<MenuItemData>["contentfulShared"]>["menuItems"]
      >[number]
    >,
    { __typename: "ContentfulEventPage" | "ContentfulRegularPage" }
  >
>;

export const getHref = (menuItem: PageMenuItemData | null): string => {
  if (menuItem === null) {
    return "";
  }

  switch (menuItem.__typename) {
    case "ContentfulEventPage":
      return `/event/${menuItem.slug}/`;
    case "ContentfulRegularPage":
      return `/${menuItem.slug}/`;
  }
};
